// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1YTFd","inputDescription":"styles_inputDescription__1pqky"};